'use strict';

require('./react-patch');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

require('./global.css');

var _application = require('./application');

var _application2 = _interopRequireDefault(_application);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// https://github.com/callemall/material-ui/issues/5070#issuecomment-244456616
require('react-dom/lib/EventPluginHub').injection.injectEventPluginsByName({
  'TapEventPlugin': require('react-dom/lib/TapEventPlugin')
});

var myRoot = document.createElement('div');

document.body.style.overflow = "hidden";

document.body.style.position = "absolute";
document.body.style.top = "0px";
document.body.style.left = "0px";
document.body.style.right = "0px";
document.body.style.bottom = "0px";
document.body.style.backgroundColor = "white";

_reactDom2['default'].render(_react2['default'].createElement(_application2['default'], null), document.body.appendChild(myRoot));

// loader entfernen (in HTML kodiert)
var bsl = document.getElementById("bootstrap-loader");
if (bsl && bsl.parentElement) bsl.parentElement.removeChild(bsl);


//////////////////
// WEBPACK FOOTER
// ./program/frontend/index.jsx
// module id = 352
// module chunks = 0